document.addEventListener('DOMContentLoaded', () => {
  if (window.customerData?.id && window.customerData?.zip) {
      console.log(window.customerData?.zip);
    const zip = window.customerData.zip;
    const matchedLocationId = mapPostalCodeToLocationId(zip);
    localStorage.setItem("userZipCode", zip)
    localStorage.setItem("zipFlag", true);
    window.inventoryInfo?.api?.selectLocation(matchedLocationId);
  } else {
    const localZip = localStorage.getItem("userZipCode");
    if(localZip && localZip !== 'null') {
        console.log("zip: ",localZip)
        const matchedLocationId = mapPostalCodeToLocationId(localZip);
        window.inventoryInfo?.api?.selectLocation(matchedLocationId);
    } else {
        fetch("https://ipapi.co/json/")
        .then(response => response.json())
        .then(data => {
            console.log("Código postal:", data.postal);
            console.log("Ciudad:", data.city);
            console.log("País:", data.country_name);

            localStorage.setItem("userZipCode", data.postal)
            localStorage.setItem("zipFlag", false);

        })
        .catch(error => {
            console.error('Error al hacer fetch:', error);
        });
    }
  }
});

function mapPostalCodeToLocationId(input) {
    const zipCode = input;
    if (!/^\d{5}$/.test(zipCode)) {
        console.warn("Código postal inválido.");
        return;
    }
    const zip = parseInt(zipCode, 10);

    const extraGuadalajaraZips = new Set([
        64170,66600,66056,66000,66650,67300,67123,67250,64710,66100,67500,67350,64000,
        36100,36300,36436,47527,36200,36700,38260,38360,38000,36970,36960,36000,36500,
        38400,38800,58500,38940,38980,58840,38900,58520,58900,76008,76146,76146,76800,
        76500,76270,76093,76240,76950,76700,37980,76000,76750,76650,38500,37729,38943,
        37950,76680,61100,61250,61500,61420,61280,58312,61421,61211,58000,61600,58420,
        58526,61800,61820,58331,58480,59920,58880,59460,61300,58970,58920,45965,58341,
        61650,61252,61080,61674,60175,61658,61659,60150,60490,60460,60443,60280,60270,
        60250,60290,60300,60440,59972,60394,60447,60400,60404,60443,60760,61278,60500,
        60521,60540,60865,61760,61790,61794,61763,61769,61730,61734,60780,61770,61750,
        61830,61840,61745,61735,61850,61860,61868,61793,60920,60980,60886,60990,60985,
        60985,60982,60982,60886,60886,60987,60987,60985,60950,60955,60985,60990,60990,
        60990,58760,58570,58600,59430,59300,59230,59250,59730,59780,59740,59987,59980,
        59920,59960,59930,59010,59510,59580,59500,59711,59550,59653,59613,59120,59200,
        59833,59180,58701,59750,47900,59716,60619,36910,47880,58400,41614,41615,41615,
        40881,40883,40138,40123,40880,41614,40850,40835,40831,40831,40882,40888,40880,
        40888,40880,40900,40910,40900,49657,40894,40903,40908,40905,40983,40904,40904,
        46570,40906,40905,40914,40966,40930,45066,40025,44330,40904,40912,40936,40935,
        40937,40932,40960,40934,39300,39380,39340,39380,39403,39390,39406,39897,39670,
        39760,39770,39800,39867,39890,39799,39715,39750,39713,39905,39810,39936,39990,
        39360,39940,39960,39120,40970,39097,44210,45680,45640,45500,45400,20920,20000,
        20300,20670,20400,20460,20700,20320,20800,1239,2010,3000,4000,5000,6140,8900,
        9430,10500,44760,13300,14000,30200,16070,52900,55700,54700,56330,55000,56530,
        11610,56343,54600,54009,54960,54900,54700,55640,52760,64330,42000, 42004, 42010,
        42014, 42015, 42018, 42020, 42026, 42027, 42029, 42030, 42032, 42033, 42034, 42035,
        42036, 42037, 42039, 42040, 42050, 42055, 42056, 42057, 42058, 42060, 42064, 42070,
        42075, 42078, 42079, 42080, 42082, 42083
    ]);

    const locationMappings = [
    { id: "69200904446", 
        ranges: [
        // { from: 44009, to: 45696 },
        { from: 44100, to: 45249 },
        { from: 45400, to: 45429 },
        { from: 45500, to: 45679 },
        { from: 49000, to: 49113 },
        ] 
    }, // Guadalajara 44100 - 44250
    {
        id: "78100529406", // Tepic 
        ranges: [
        { from: 63000, to: 63529 },
        { from: 63780, to: 63799 },
        ],
    },
    ];

    let matchedLocationId = "70672580862"; // CDMX

    if (extraGuadalajaraZips.has(zip)) {
        matchedLocationId = "69200904446";
    } else {
        for (const location of locationMappings) {
            const found = location.ranges.some(
                (range) => zip >= range.from && zip <= range.to,
            );
            if (found) {
                matchedLocationId = location.id;
                break;
            }
        }
    }

  return matchedLocationId;
//     return 70672580862
}